// ---------------------------------------------------------------------------
// SpeedyDock SDK — Search Widget
// ---------------------------------------------------------------------------

import { SDK_PREFIX } from "./styles";
import type { SearchWidgetOptions } from "./types";
import { resolveElement, createElement } from "./utils";

/**
 * Renders a small date picker + "Check Availability" button.
 * On submit it opens the booking flow in the chosen mode.
 */
export function createSearchWidget(
  openBooking: (date?: string) => void,
  target: string | HTMLElement,
  options: SearchWidgetOptions = {},
): { destroy(): void } {
  const container = resolveElement(target);
  if (!container) throw new Error(`[SpeedyDock] Target "${target}" not found.`);

  const wrapper = createElement("div", `${SDK_PREFIX}-search`);

  const input = createElement("input", undefined, {
    type: "date",
    "aria-label": "Select a date",
  });
  if (options.placeholder) input.placeholder = options.placeholder;

  // Default to today
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  input.value = `${yyyy}-${mm}-${dd}`;
  input.min = input.value;

  const btn = createElement("button");
  btn.textContent = "Check Availability";

  btn.addEventListener("click", () => {
    const val = input.value;
    // Convert YYYY-MM-DD to MM/DD/YYYY for the booking app
    const date = val
      ? `${val.slice(5, 7)}/${val.slice(8, 10)}/${val.slice(0, 4)}`
      : undefined;
    openBooking(date);
  });

  wrapper.appendChild(input);
  wrapper.appendChild(btn);
  container.appendChild(wrapper);

  return {
    destroy() {
      wrapper.remove();
    },
  };
}
